// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/Menu7/Item.css
// module id = 2039
// module chunks = 0